import { Injectable } from '@angular/core';
import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  instance:ApplicationInsights;
  constructor() { 
    this.instance = new ApplicationInsights({
        config:{instrumentationKey:environment.appInsights.instrumentationKey,
          enableAutoRouteTracking:true
        }
      });
      // this.instance.loadAppInsights();
      // this.instance.trackPageView();
  }

  logPageView(name?: string, url?: string) { // option to call manually
   // this.instance.trackPageView({ name: name, uri: url });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
   // this.instance.trackEvent({ name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
   // this.instance.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    //this.instance.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
   // this.instance.trackTrace({ message: message}, properties);
  }

  setAuthenticatedUserId(userId: string): void {
    //console.log(userId);
    this.instance.setAuthenticatedUserContext(userId);
}

}
